(function ($) {

	$('.js-collapse').on('click', function () {
	    $(this).toggleClass('open');
		$(this).hasClass("open") === true ? $(this).attr("aria-expanded", "true") : $(this).attr("aria-expanded", "false");
		$(this).siblings('.js-collapsable').slideToggle();
	});

	$('.js-collapsed-breadcrumb').on('click', function () {
		$(this).prev().removeClass('sr-only');
		$(this).remove();
	});

})(jQuery);
